import apiClient from "./apiClient";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import {ActReconciliation} from "@/types/act";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function createActReconciliation(params: any): Promise<ActReconciliation[]> {
    try {
        const response = await apiClient.post<ActReconciliation[]>(
            `${BASE_URL}/api/v1/act/create`, params
        )
        return response.data;
    } catch (error) {
        console.error("Error act create:", error);
        throw error;
    }
}

export async function getAllActReconciliations(params: any): Promise<any> {
    try {
        const paramsCopy = structuredClone(params);
        paramsCopy.filter = removeNullFields(paramsCopy.filter);

        const response = await apiClient.post<any>(
            `${BASE_URL}/api/v1/act/all`, paramsCopy
        )
        return response.data;
    } catch (error) {
        console.error("Error act all:", error);
        throw error;
    }
}

export async function refreshActReconciliation(data: ActReconciliation): Promise<ActReconciliation> {
    try {
        const response = await apiClient.post<ActReconciliation>(
            `${BASE_URL}/api/v1/act/refresh`, data
        )
        return response.data;
    } catch (error) {
        console.error("Error act refresh:", error);
        throw error;
    }
}

export async function acceptActReconciliation(data: ActReconciliation): Promise<ActReconciliation> {
    try {
        const response = await apiClient.post<ActReconciliation>(
            `${BASE_URL}/api/v1/act/accept`, data
        )
        return response.data;
    } catch (error) {
        console.error("Error act accept:", error);
        throw error;
    }
}

export async function generateReport(templateType: TemplateTypeEnum, params: any): Promise<any> {
    try {
        const paramsCopy = structuredClone(params);
        paramsCopy.filter = removeNullFields(paramsCopy.filter);

        return await apiClient.post<any>(
            `${BASE_URL}/api/v1/act/report/generate/${templateType}`,
            paramsCopy,
            {
                responseType: "blob"
            }
        )
    } catch (error) {
        console.error("Error act report generate:", error);
        throw error;
    }
}